module.exports = __webpack_public_path__ + "fonts/0061ab1d-ac0a-492f-a33d-d95980a095a8.0b4a586a.eot";